import { Icon } from 'office-ui-fabric-react/lib/Icon';
import * as React from 'react';
import TxpStyle from 'txp-data/lib/schema/viewSchema/TxpStyle';
import { DetailsLine } from './DetailsLine';
import TxpImages from 'txp-data/lib/schema/configSchema/TxpImages';
import FlightCardItem from 'txp-data/lib/schema/viewSchema/FlightCardItem';

let styles = require('./FlightCard.scss');
let classNames = require('classnames');

export interface FlightCardProps {
    flightCardItem: FlightCardItem;
    txpStyle: TxpStyle;
    txpImages?: TxpImages;
}

function FlightCard(props: FlightCardProps) {
    let { flightCardItem, txpStyle, txpImages } = props;
    const airPlaneIcon =
        txpImages && txpImages.detailsIcons ? txpImages.detailsIcons.airPlaneSolid : '';

    let { departureTerminal, departureGate, arrivalTerminal, arrivalGate, seat } = flightCardItem;

    let flightTerminalGateStyle = [styles.row];
    let showTerminalGate =
        departureTerminal || departureGate || arrivalTerminal || arrivalGate || seat;

    if (txpStyle.flightTerminalGate) {
        flightTerminalGateStyle.push(txpStyle.flightTerminalGate);
    }

    let flightLineStyle = flightCardItem.isFutureFlight ? styles.futureFlight : null;
    return (
        <div>
            <div className={txpStyle.flightDetails || ''}>
                <div className={styles.row}>
                    <div className={styles.iata}>{flightCardItem.departureIATA}</div>
                    <div className={classNames(styles.lineContainer, flightLineStyle)}>
                        <Icon className={txpStyle.planeStyle} iconName={airPlaneIcon} />
                        <div className={styles.line} />
                    </div>
                    <div className={styles.iata}>{flightCardItem.arrivalIATA}</div>
                </div>
                <div className={styles.row}>
                    <div className={styles.leftColumn}>
                        <div className={styles.time}>{flightCardItem.departureTime}</div>
                        <div className={styles.smallText}>{flightCardItem.departureDate}</div>
                        <div className={styles.smallText}>{flightCardItem.departureCity}</div>
                    </div>
                    <div className={styles.rightColumn}>
                        <div className={styles.time}>{flightCardItem.arrivalTime}</div>
                        <div className={styles.smallText}>{flightCardItem.arrivalDate}</div>
                        <div className={styles.smallText}>{flightCardItem.arrivalCity}</div>
                    </div>
                </div>
            </div>
            {showTerminalGate && (
                <div className={classNames(flightTerminalGateStyle)}>
                    {flightCardItem.arrivalsIcon && (
                        <Icon
                            iconName={flightCardItem.arrivalsIcon}
                            className={txpStyle.iconStyle}
                        />
                    )}
                    <div className={styles.terminalGateContainer}>
                        <div className={styles.leftColumn}>
                            <DetailsLine
                                detailsData={departureTerminal}
                                txpStyle={txpStyle}
                                isFlightCardLine={true}
                            />
                            <DetailsLine
                                detailsData={departureGate}
                                txpStyle={txpStyle}
                                isFlightCardLine={true}
                            />
                            <DetailsLine
                                detailsData={seat}
                                txpStyle={txpStyle}
                                isFlightCardLine={true}
                            />
                        </div>
                        <div className={styles.rightColumn}>
                            <DetailsLine
                                detailsData={arrivalTerminal}
                                txpStyle={txpStyle}
                                isFlightCardLine={true}
                            />
                            <DetailsLine
                                detailsData={arrivalGate}
                                txpStyle={txpStyle}
                                isFlightCardLine={true}
                            />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
export default FlightCard;
